import { Injectable, inject } from '@angular/core'
import { select, Store, Action } from '@ngrx/store'

import * as CustomerPaymentMethodsSelectors from './customer-payment-methods.selectors'

@Injectable({
  providedIn: 'root',
})
export class CustomerPaymentMethodsFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.pipe(select(CustomerPaymentMethodsSelectors.selectCustomerPaymentMethodsLoaded))
  allCustomerPaymentMethods$ = this.store.pipe(select(CustomerPaymentMethodsSelectors.selectAllCustomerPaymentMethods))

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
